import { render, staticRenderFns } from "./DeleteLideres.vue?vue&type=template&id=6006ec6a&scoped=true"
import script from "./DeleteLideres.vue?vue&type=script&lang=js"
export * from "./DeleteLideres.vue?vue&type=script&lang=js"
import style0 from "./DeleteLideres.vue?vue&type=style&index=0&id=6006ec6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6006ec6a",
  null
  
)

export default component.exports